import React from "react";
import { Card, Empty } from "antd";
import { useTranslation } from "react-i18next";
import "./SesionesPorCategoriaLista.scss";

/**
 * =============================================================================
 * SESIONES POR CATEGORIA, EN LISTA
 * =============================================================================
 * Sustituye al grafico de sectores por debajo de 768 px, con los mismos datos.
 *
 * El motivo no es el tamano: es que un grafico de sectores **solo entrega sus
 * numeros al pasar el raton por encima**, y en una pantalla tactil el navegador
 * dispara ese gesto a la vez que el toque. O sea que la cifra aparece cuando ya
 * has tocado, si es que aparece.
 *
 * La lista los escribe. Y de paso muestra el total, que en el grafico era
 * configuracion que nunca llegaba a verse.
 * =============================================================================
 */
export function SesionesPorCategoriaLista({ loading, charts }) {
  const { t } = useTranslation("motricity");
  // Las mismas claves y el mismo tratamiento que el grafico al que sustituye:
  // el servidor emite un cubo sin categoria, y sin resolverlo la fila saldria
  // sin rotulo y sin clave estable.
  const filas = (charts?.distribution || []).map((fila) =>
    fila?.name
      ? fila
      : { ...fila, name: t("charts.distribucion.sinCategoria") },
  );
  const total = filas.reduce((suma, f) => suma + (f.value || 0), 0);

  return (
    <Card
      loading={loading}
      variant="outlined"
      className="revi-categorias-lista"
      title={
        <div className="revi-categorias-lista__titulo">
          <span>{t("charts.distribucion.titulo")}</span>
          <span className="revi-categorias-lista__total">{total}</span>
        </div>
      }
    >
      {filas.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={t("charts.distribucion.vacio")}
        />
      ) : (
        <ul className="revi-categorias-lista__filas">
          {filas.map((fila, i) => (
            <li
              key={`${fila.name}-${i}`}
              className="revi-categorias-lista__fila"
            >
              <span
                className="revi-categorias-lista__punto"
                style={{ background: fila.color }}
                aria-hidden
              />
              <span className="revi-categorias-lista__nombre">{fila.name}</span>
              <span className="revi-categorias-lista__valor">{fila.value}</span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
